export var DEFAULT_API_ENDPOINT = 'https://domain-proxy.sosafe.de/amplitudev2';
export var LOG_INACTIVE_PREFIX = '[PRODUCT ANALYTICS INACTIVE]';
//# sourceMappingURL=constant.js.map